export default [
  //新增题库
  {
    path: "tk/tkgl/ques-bank-add",
    name: "QuesBankAdd",
    component: () => import('./tkgl/QuesBankAdd.vue')
  },

  //题库列表
  {
    path: "tk/tkgl/ques-bank-list",
    name: "QuesBankList",
    component: () => import('./tkgl/QuesBankList.vue')
  },

  //新增试题
  {
    path: "tk/tkgl/ques-add",
    name: "QuesAdd",
    component: () => import('./tkgl/QuesAdd.vue')
  },

  //批量导入试题
  {
    path: "tk/tkgl/btach-import-ques-txt",
    name: "BtachImportQuesTxt",
    component: () => import('./tkgl/BtachImportQuesTxt.vue')
  },
  {
    path: "tk/tkgl/btach-import-ques-excel",
    name: "BtachImportQuesExcel",
    component: () => import('./tkgl/BtachImportQuesExcel.vue')
  },
  {
    path: "tk/tkgl/btach-import-ques-word",
    name: "BtachImportQuesWord",
    component: () => import('./tkgl/BtachImportQuesWord.vue')
  },
  //管理试题
  {
    path: "tk/tkgl/ques-list",
    name: "QuesList",
    component: () => import('./tkgl/QuesList.vue')
  },
  {
    path: "tk/tkgl/ques-edit",
    name: "QuesEdit",
    component: () => import('./tkgl/QuesEdit.vue')
  },
  //套题子题list
  {
    path: "tk/tkgl/tao-ti-list",
    name: "TaoTiList",
    component: () => import('./tkgl/TaoTiList.vue')
  },
  //套题子题新增
  {
    path: "tk/tkgl/tao-ti-add",
    name: "QuesTaotAdd",
    component: () => import('./tkgl/QuesTaotAdd.vue')
  },
  //套题子题修改
  {
    path: "tk/tkgl/tao-ti-edit",
    name: "QuesTaotEdit",
    component: () =>  import('./tkgl/QuesTaotEdit.vue')
  },
];

